export var imageResizeModeToFileImageMode = function imageResizeModeToFileImageMode(resizeMode) {
  return resizeMode === 'stretchy-fit' ? 'full-fit' : resizeMode;
};